import { inject, Injectable, signal } from '@angular/core';
import { AuthApiService } from '../services/auth-api.service';
import {
  IJwtResponseDto,
  ILoginRequestDto,
  ILoginSuccessResponse,
} from '../models/auth.models';
import { SessionService } from '../services/session.service';
import { AuthServerClockService } from '../services/auth-server-clock.service';
import { UserTypeStateService } from '../state/user-type-state.service';
import { AuthSessionPromotersUtil } from '../utils/auth-session-promoters';

@Injectable({
  providedIn: 'root',
})
export class LoginStateService {
  private authApiService = inject(AuthApiService);
  private userTypeService = inject(UserTypeStateService);
  private authServicePromotersUtil = inject(AuthSessionPromotersUtil);

  tokenData = signal<IJwtResponseDto | null>(null);
  responseLoginSuccess = signal<ILoginSuccessResponse | null>(null);
  isLoggingIn = signal(false);
  error = signal<string | null>(null);

  tokenDataByGoogle = signal<IJwtResponseDto | null>(null);
  responseLoginSuccessByGoogle = signal<ILoginSuccessResponse | null>(null);
  isLoggingInByGoogle = signal(false);
  errorByGoogle = signal<string | null>(null);

  private sessionService = inject(SessionService);
  private serverClock = inject(AuthServerClockService);

  login(request: ILoginRequestDto) {
    this.isLoggingIn.set(true);
    this.error.set(null);
    this.tokenData.set(null);
    this.responseLoginSuccess.set(null);
    this.authApiService.loginUser(request).subscribe({
      next: (response: ILoginSuccessResponse) => {
        this.tokenData.set(response.data);
        this.responseLoginSuccess.set(response);

        const token = response.data?.access_token || '';
        this.serverClock.synchronize(response.timestamp);
        localStorage.setItem('accessToken', token);

        this.sessionService.startSessionTimer(token);
        this.isLoggingIn.set(false);
      },
      error: (err) => {
        this.error.set('Error al iniciar sesión.');
        this.isLoggingIn.set(false);
        console.error('Error al iniciar sesión:', err);
      },
    });
  }

  logout() {
    this.tokenData.set(null);
    localStorage.removeItem('accessToken');
    sessionStorage.clear();
  }

  checkEmailAndGenerateToken(email: string) {
    this.isLoggingInByGoogle.set(true);
    this.errorByGoogle.set(null);
    this.tokenDataByGoogle.set(null);
    this.responseLoginSuccessByGoogle.set(null);
    this.authApiService.checkEmailAndGenerateToken(email).subscribe({
      next: (response: ILoginSuccessResponse) => {
        this.tokenDataByGoogle.set(response.data);
        this.responseLoginSuccessByGoogle.set(response);

        const token = response.data?.access_token || '';
        this.serverClock.synchronize(response.timestamp);
        localStorage.setItem('accessToken', token);

        this.sessionService.startSessionTimer(token);

        this.isLoggingInByGoogle.set(false);
      },
      error: (err) => {
        this.errorByGoogle.set('No se pudo iniciar sesión.');
        //this.responseLoginSuccessByGoogle.set(err.error);
        this.isLoggingInByGoogle.set(false);
        console.error('Error al iniciar sesión:', err);
      },
    });
  }
}
